(function ($) {

    $.fn.moveTop = function () {

        var elem = $(this);
        var duration = 800;
        var offset = 220;

        $(window).scroll(function () {
            if ($(window).scrollTop() > offset) {
                elem.fadeIn(duration);
            } else {
                elem.fadeOut(duration);
            }
        });

        elem.click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, duration);
        });
    };

    $.fn.optimusDropDown = function () {

        var dropDown = $(this);

        function processDropDown(btn, hover) {
            var container = btn.closest(".drop-down-wrap");
            var body = container.find(".drop-down-body");
            var content = body.find(".drop-down-content");
            var area = container.find(".drop-down-area");
            var windowWidth = $(window).width();

            var defaultOptions = {
                directionX: "right",
                directionY: "down",
                controlWidth: "window",
                bottom: btn
            };

            if (isDefined(container.data("settings"))) {
                console.log(container.data("settings"));
                parseOptions(defaultOptions, container.data("settings"));
            }

            if (!isObject(defaultOptions.controlWidth)) {
                if (defaultOptions.controlWidth === "window") {
                    defaultOptions.controlWidth = $(window);
                } else if (defaultOptions.controlWidth === "parent") {
                    defaultOptions.controlWidth = container.parent();
                } else if (defaultOptions.controlWidth === "body") {
                    defaultOptions.controlWidth = $("body");
                } else if (/closest:.*/.test(defaultOptions.controlWidth)) {
                    var pointer = str_replace(defaultOptions.controlWidth, "closest:", "", 1);
                    defaultOptions.controlWidth = btn.closest(pointer);
                } else {
                    defaultOptions.controlWidth = $(document).find(defaultOptions.controlWidth);
                }
            }

            /*if ($.dialog.moveToBody(container) && !$.dialog.moveToBody(defaultOptions.controlWidth)) {
                defaultOptions.controlWidth = $.dialog.moveToBody(container);
            }*/

            if (!isObject(defaultOptions.bottom)) {
                defaultOptions.bottom = btn.closest(defaultOptions.bottom);
            }

            if (container.data("opened") === true) {
                return;
            }

            if (!hover) {
                $(document).find(".drop-down-wrap").not(container).find(".drop-down-body").slideUp(200);
            } else {
                if (windowWidth >= 640) {
                    $(document).find(".drop-down-wrap.info").not(container).find(".drop-down-body").slideUp(200);
                }
            }

            var bodyWidth = body.outerWidth(true);
            var bodyLeft = container.offset().left;
            var parentWidth = defaultOptions.controlWidth.outerWidth(true);
            var parentLeft = 0;

            if (!defaultOptions.controlWidth.is($(window))) {
                parentLeft = defaultOptions.controlWidth.offset().left;
            }

            function recalculatePosition() {

                var bodyOffset, bodyLimitHeight;
                var bottom = defaultOptions.bottom.outerHeight(true);

                if (defaultOptions.controlWidth.hasClass("edit-content")) {
                    bodyOffset = container.offset().top - defaultOptions.controlWidth.offset().top - 5;
                    bodyLimitHeight = defaultOptions.controlWidth.offset().top + defaultOptions.controlWidth.outerHeight(true) - container.offset().top - 5;
                } else {
                    bodyOffset = container.offset().top - $(window).scrollTop() - 20;
                    bodyLimitHeight = $(window).scrollTop() + $(window).height() - container.offset().top - 20;
                }

                var bodyRealHeight = body.find(".drop-down-content").prop('scrollHeight');

                if (defaultOptions.directionY === "up") {
                    if (bodyRealHeight > bodyOffset) {
                        body.css({"top": bottom, "bottom": "auto", "max-height": bodyLimitHeight + "px"});
                    } else {
                        body.css({"bottom": bottom, "top": "auto", "max-height": bodyOffset + "px"});
                    }
                } else {
                    if (bodyRealHeight > bodyLimitHeight && bodyOffset > bodyLimitHeight) {
                        body.css({"bottom": bottom, "top": "auto", "max-height": bodyOffset + "px"});
                    } else {
                        body.css({"top": bottom, "bottom": "auto", "max-height": bodyLimitHeight + "px"});
                    }
                }

                content.css({"min-width": area.outerWidth(true)});
                body.css({"min-width": area.outerWidth(true)});

                if (content.outerHeight(true) > body.css("max-height")) {
                    content.css({"overflow-y": "scroll"});
                }

                if (windowWidth <= 640) {
                    var winW = $(window).width();
                    bodyWidth = winW - 50;
                    body.css({"width": bodyWidth});

                    if ((bodyLeft + bodyWidth) > (parentWidth + parentLeft)) {
                        body.css({
                            "right": btn.offset().left + btn.outerWidth(true) - winW + ((winW - bodyWidth) / 2),
                            "left": "auto"
                        });
                    } else {
                        body.css({"right": "auto", "left": 0});
                    }
                } else {

                    var width;
                    width = (parentLeft + parentWidth) - btn.offset().left;
                    body.css({"width": width});
                    if (container.hasClass("info")) {
                        body.css({"top": (btn.outerHeight(true) + 10) + "px"});
                    }

                    if (defaultOptions.directionX === "right") {
                        body.removeClass("right-to-left");
                        if ((bodyLeft + bodyWidth) > (parentWidth + parentLeft)) {
                            body.css({
                                "right": "auto",
                                "left": (btn.offset().left + btn.outerWidth(true)) + (btn.offset().left - container.offset().left) - bodyWidth
                            });
                        } else {
                            body.css({"right": "auto", "left": 0});
                        }
                    } else {
                        if ((bodyLeft) > (parentLeft)) {
                            body.css({"right": 0, "left": "auto"});
                            body.addClass("right-to-left");
                        } else {
                            body.css({"right": "auto", "left": 0});
                            body.removeClass("right-to-left");
                        }
                    }
                }
            }

            function showContent(down, elem, callback) {
                if (!isDefined(down)) {
                    down = true;
                }
                if (down) {
                    elem.slideDown(200, function () {
                        btn.addClass("hover");
                        if (isFunction(callback)) {
                            callback();
                        }
                    });
                } else {
                    elem.slideUp(200, function () {
                        btn.removeClass("hover");
                        if (isFunction(callback)) {
                            callback();
                        }
                    });
                }
            }

            recalculatePosition();

            if (!body.is(":visible")) {
                showContent(true, body);
            } else {
                showContent(false, body);
            }

            $(document).click(function (e) {
                if (!body.is(e.target) && body.has(e.target).length === 0 && !$(e.target).closest(".drop-down-area").length) {
                    showContent(false, body);
                }
            });

            recalculatePosition();
        }

        dropDown.on("click touch", ".drop-down-area", function (e) {
            e.preventDefault();
            processDropDown($(this), false);
        });

        dropDown.on("mouseenter", ".drop-down-area.on-hover", function (e) {
            var el = $(this);
            var stop = false;

            if (isDefined(el.data("no-prevent"))) {
                if (el.data("no-prevent")) {
                    stop = true;
                }
            }

            if (!e.hadnled) {
                if (!stop) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                processDropDown($(this), true);
                e.handled = true;
            }
        });
    };
})(jQuery);

